export const HeroHeader = {
  TextField: 'text-field',
  HeroCta: 'hero-cta',
};
